import {BLOCK_REGISTRY} from "../lib/registry";
import "./Editor.scss";

export const BlockRenderer = ({block}) => {
    const Component = BLOCK_REGISTRY[block.type];

    if (!Component) {
        console.warn(`Unknown block type: «${block.type}»`);
        return null;
    }

    return <Component {...block.data} />;
};
